
import React from "react";
import { Site } from "@/services/types";

interface SitesHeaderProps {
  isDeptPage: boolean;
  deptName: string;
  deptParam: string | null;
  filteredSites: Site[];
}

const SitesHeader: React.FC<SitesHeaderProps> = ({
  isDeptPage,
  deptName,
  deptParam,
  filteredSites
}) => {
  return (
    <header className="mb-16 text-center">
      <div className="flex items-center justify-center gap-4 mb-8">
        <img 
          src="/lovable-uploads/2e9c2ce6-c821-428b-baa4-bd3137a03d49.png" 
          alt="Logo Groupe Fabre Environnement - Spécialiste gestion des déchets" 
          className="w-20 h-20 drop-shadow-lg"
          loading="eager"
        />
        <div>
          <h1 className="text-4xl md:text-6xl font-heading font-bold text-fabre-gray">
            {isDeptPage ? `Nos Sites ${deptName}` : "Nos Sites de Recyclage"}
          </h1>
          {isDeptPage && (
            <p className="text-lg text-fabre-teal font-medium mt-2">
              Département {deptParam} - {filteredSites.length} centre(s) à votre service
            </p>
          )}
        </div>
      </div>
      <div className="w-32 h-1 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-8"></div>
      <div className="max-w-4xl mx-auto">
        <p className="text-xl md:text-2xl text-fabre-darkteal leading-relaxed mb-6">
          {isDeptPage 
            ? `Découvrez nos ${filteredSites.length} centres de recyclage et de gestion des déchets dans ${deptName}. Solutions professionnelles pour particuliers, entreprises et collectivités.`
            : `Groupe Fabre Environnement dispose de ${filteredSites.length} sites spécialisés dans la collecte, le tri et la valorisation des déchets. Trouvez le centre le plus proche de chez vous.`
          }
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div className="bg-white/70 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-fabre-green/20">
            <h3 className="text-2xl font-bold text-fabre-green mb-2">{filteredSites.length}+</h3>
            <p className="text-fabre-darkteal font-medium">Sites de recyclage</p>
          </div>
          <div className="bg-white/70 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-fabre-teal/20">
            <h3 className="text-2xl font-bold text-fabre-teal mb-2">25+</h3>
            <p className="text-fabre-darkteal font-medium">Années d'expertise</p>
          </div>
          <div className="bg-white/70 backdrop-blur-sm rounded-xl p-6 shadow-lg border border-fabre-gold/20">
            <h3 className="text-2xl font-bold text-fabre-gold mb-2">100%</h3>
            <p className="text-fabre-darkteal font-medium">Valorisation locale</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default SitesHeader;
